<div class="main-container-left-side">
  <left-sport-menu-desktop></left-sport-menu-desktop>
</div>

<div class="main-container-mid-side">
  <div class="container">
    <div class="header">
      <div class="header-text whiteText">
        {{ 'Sports' | t }}
      </div>
      <div class="arrow-icon down"></div>
    </div>
    <outrights-component [setTournamentLegacy]="this.tourid"></outrights-component>
  </div>
</div>
